export default "__VITE_ASSET__Bl5KXWTg__"